export { default } from './PostsTemplate';
export * from './PostsTemplate';
export * from './PostsTemplate.types';
